import * as R from 'ramda'
import { createSelector } from 'reselect'

import {
  createSelectorWithPath,
  labelSelectorFunc,
  entitiesSelector
} from 'helpers/ComponentSelectorUtil'
import {
  TRUE,
  FALSE,
} from 'components/custom/FeatureButton/constants'

const sourcesSelectorFunc = state => state.sources
const valuesSelectorFunc = state => state.values

const sourcesSelectorHoc = (sourcesSelector) => (
  createSelector(
    entitiesSelector,
    sourcesSelector,
    (entities, refs) => {
      return (
      refs.map(({id, type}) => {
      const source = entities[type][id]
      return { ...source }
    }))}
  )
)

const doesValueContain = (value) => R.contains(R.prop('value', value))
const sortByDisabled = R.sortBy(R.complement(R.prop('disabled')))
const mapLabelByFeatureValue = features => R.map(src => doesValueContain(src)(features)
  ? { ...src, label: TRUE }
  : { ...src, label: FALSE }
)

const mapAndSortFeatures = features => R.compose(
  sortByDisabled,
  mapLabelByFeatureValue(features)
)
/*
 * use selectors to general the labels don't create them within the object
 */
const valuesSelectorHoc = (sourcesSelector, valuesSelector) => (
  createSelector(
    sourcesSelector,
    valuesSelector,
    (sources, values) => {
      const features = R.map(R.prop('value'))(values)
      return mapAndSortFeatures(features)(sources)
    }
  )
)

export default (pathName) => {
  const withPath = createSelectorWithPath(pathName)

  const sourcesSelectorRef = withPath(sourcesSelectorFunc)
  const valuesSelectorRef = withPath(valuesSelectorFunc)

  const sourcesSelector = sourcesSelectorHoc(sourcesSelectorRef)
  const valuesSelector = valuesSelectorHoc(sourcesSelector, valuesSelectorRef)

  return {
    sourcesSelector,
    valuesSelector,
  }
}
